import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../lib/api';
import CatalogBrowser from '../components/shop/CatalogBrowser';
import SEO from '../components/SEO';

export default function CollectionDetail() {
    const { slug } = useParams();
    const [collection, setCollection] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.get(`/collections/${slug}`)
            .then((c) => setCollection(c.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, [slug]);

    if (loading) return <div className="py-20 text-center eyebrow" style={{ color: 'var(--ink-muted)' }}>Loading...</div>;
    if (!collection) return <div className="py-20 text-center font-serif text-3xl" style={{ color: 'var(--brand-burgundy)' }}>Collection not found</div>;

    return (
        <div data-testid="collection-detail-page">
            <SEO
                title={collection.name}
                description={collection.description || `Explore the ${collection.name} collection by anfal.`}
                image={collection.cover_image}
                canonical={`/collections/${collection.slug}`}
            />
            <section className="relative" style={{ minHeight: '46vh' }}>
                <div className="absolute inset-0">
                    {collection.cover_image && (
                        <img src={collection.cover_image} alt={collection.name} className="w-full h-full object-cover" />
                    )}
                    <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0.55) 100%)' }} />
                </div>
                <div className="relative z-10 max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-10 py-20 lg:py-24">
                    <Link to="/collections" className="eyebrow text-white/85 hover:text-white">&lsaquo; All collections</Link>
                    <h1 className="font-serif text-white text-5xl md:text-7xl mt-4 leading-[0.95]" data-testid="collection-title">{collection.name}</h1>
                    {collection.description && <p className="mt-4 text-white/90 max-w-xl text-base md:text-lg">{collection.description}</p>}
                </div>
            </section>

            <section className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-10 py-10 lg:py-14">
                <CatalogBrowser lockedCollection={collection.slug} />
            </section>
        </div>
    );
}
